<template>
  <div ref="main" class="main-wrapper" :class="{ 'init': initialized.cucumber && initialized.stream, 'hovering': hovering }">
    <video class="monitor" ref="monitor" autoplay width="160" height="120" style="visibility: hidden; float:left;"></video>
  </div>
</template>

<script>
import * as THREE from 'three'
import OBJLoader from 'three-obj-loader'

OBJLoader(THREE)

export default {
  name: 'Main',
  data() {
    return {
      initialized: {
        cucumber: false,
        stream: false,
      },
      mouse: new THREE.Vector2(),
      scene: undefined,
      camera: undefined,
      renderer: undefined,
      cube: undefined,
      cucumber: undefined,
      hovering: false,
      cucumberMaterial: undefined,
      cucumberHoverMaterial: undefined,
      cucumberReflectionCamera: undefined,
      loader: undefined,
      stream: undefined,
      videoTexture: undefined,
      skybox: new THREE.Mesh(),
      raycaster: undefined,
      mouseMoved: false,
      screenOrientation: (window.innerWidth > window.innerHeight) ? 'landscape' : 'portrait',
    }
  },
  mounted() {
    this.initVideo()

    window.addEventListener('mousemove', this.handleMousemove, false)
    window.addEventListener('resize', this.onWindowResize, false)

    this.scene = new THREE.Scene()
    this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 50)

    this.renderer = new THREE.WebGLRenderer({
      antialias: true,
      // alpha: true,
    })
    this.scene.background = new THREE.Color(0xffffff)
    this.renderer.setPixelRatio(window.devicePixelRatio ? window.devicePixelRatio : 1)
    this.renderer.setSize(window.innerWidth, window.innerHeight)
    this.$refs.main.appendChild(this.renderer.domElement)

    this.camera.position.z = 20

    this.setCameraOrientation()

    this.initVideoTexture()

    this.addSkyBox()

    this.loadCucumber()

    this.initRaycaster()


    const upperlight = new THREE.PointLight(0xffffff, 6, 100)
    upperlight.position.set(-40, 40, 40)
    this.scene.add(upperlight)

    const lowerlight = new THREE.PointLight(0xffffff, 3, 100)
    lowerlight.position.set(20, -50, -20)
    this.scene.add(lowerlight)

    this.animate()
  },
  watch: {
    hovering(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal) {
          this.cucumber.children[0].material = this.cucumberHoverMaterial
        } else {
          this.cucumber.children[0].material = this.cucumberMaterial
        }
      }
    },
  },
  methods: {

    initRaycaster() {
      this.raycaster = new THREE.Raycaster()
    },

    onWindowResize() {
      this.screenOrientation = (window.innerWidth > window.innerHeight) ? 'landscape' : 'portrait'
      this.camera.aspect = window.innerWidth / window.innerHeight
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(window.innerWidth, window.innerHeight)
      this.setCameraOrientation()
    },

    initVideo() {
      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia

      if (!navigator.getUserMedia) {
        this.noStream()
      } else {
        navigator.getUserMedia({ video: true }, this.gotStream, this.noStream)
      }
    },

    noStream(e) {
      console.log('E', e)
      console.log('not have a stream!')
      this.stream = false
      this.initialized.stream = true
    },

    gotStream(stream) {
      console.log('have a stream!')
      const camvideo = this.$refs.monitor

      this.stream = true
      this.initialized.stream = true

      try {
        camvideo.srcObject = stream
      } catch (error) {
        camvideo.src = URL.createObjectURL(stream)
      }

      camvideo.onerror = (e) => {
        stream.stop()
        this.stream = false
      }

      stream.onended = this.noStream
    },

    initVideoTexture() {
      const video = this.$refs.monitor

      this.videoTexture = new THREE.VideoTexture(video)
      console.log('THIS.VIDEOTEXTURE', this.videoTexture)
      this.videoTexture.mapping = THREE.EquirectangularReflectionMapping
      this.videoTexture.minFilter = THREE.NearestFilter
      this.videoTexture.magFilter = THREE.LinearFilter
      this.videoTexture.format = THREE.RGBFormat
    },

    handleMousemove(event) {
      if (!this.mouseMoved) {
        this.mouseMoved = true
      }
      this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1
      this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1
    },

    loadCucumber() {
      this.loader = new THREE.OBJLoader()

      this.loader.load(
        './cucumber4.obj',
        (object) => {
          this.cucumber = object
          this.cucumberInit()
        },
        (xhr) => {
          console.log(`${xhr.loaded / xhr.total * 100}% loaded`)
        },
        (error) => {
          console.log('ERROR', error)
        },
      )
    },

    addSkyBox() {
      const movieMaterial = new THREE.MeshBasicMaterial({ map: this.videoTexture, overdraw: true, side: THREE.DoubleSide })
      const skyGeometry = new THREE.SphereGeometry(500, 32, 32)
      // this.skybox = new THREE.Mesh(skyGeometry, movieMaterial)
      this.skybox.material = movieMaterial
      this.skybox.geometry = skyGeometry
      this.scene.add(this.skybox)
    },

    cucumberInit() {
      const map = new THREE.TextureLoader().load('./cucumber_map.jpg')
      this.cucumberReflectionCamera = new THREE.CubeCamera(0.1, 5000, 512)
      this.scene.add(this.cucumberReflectionCamera)

      this.cucumberHoverMaterial = new THREE.MeshStandardMaterial({
        map,
        bumpMap: new THREE.TextureLoader().load('./cucumber_bump.jpg'),
        bumpScale: 0.015,
        normalMap: new THREE.TextureLoader().load('./cucumber_normal.jpg'),
        normalScale: new THREE.Vector2(0.4, 0.4),
        metalnessMap: new THREE.TextureLoader().load('./cucumber_metalness.jpg'),
        metalness: 0.1,
        roughness: 0.7,
        emissive: new THREE.Color(0xffffff),
        emissiveMap: map,
        emissiveIntensity: 0.2,
        envMap: this.cucumberReflectionCamera.renderTarget.texture,
      })

      this.cucumberMaterial = new THREE.MeshStandardMaterial({
        bumpMap: new THREE.TextureLoader().load('./cucumber_bump.jpg'),
        bumpScale: 0.015,
        normalMap: new THREE.TextureLoader().load('./cucumber_normal.jpg'),
        normalScale: new THREE.Vector2(0.4, 0.4),
        metalness: 1,
        roughness: 0,
        envMap: this.cucumberReflectionCamera.renderTarget.texture,
      })

      if (this.stream === false) {
        this.cucumber.children[0].material = this.cucumberHoverMaterial
      } else {
        this.cucumber.children[0].material = this.cucumberMaterial
      }

      this.scene.add(this.cucumber)

      this.initialized.cucumber = true
    },

    radians(degrees) {
      return (degrees * Math.PI) / 180
    },

    degrees(radians) {
      return (radians * 180) / Math.PI
    },

    setCameraOrientation() {
      if (this.skybox) {
        if (this.screenOrientation === 'portrait') {
          this.camera.rotation.z = 1.5708
          this.skybox.rotation.y = 0
          this.skybox.rotation.x = this.radians(90)
          this.skybox.rotation.z = this.radians(90)
        } else {
          this.camera.rotation.z = 0
          this.skybox.rotation.y = this.radians(270)
          this.skybox.rotation.x = 0
          this.skybox.rotation.z = 0
        }
      }
    },

    animate() {
      if (this.cucumber) {
        this.cucumber.rotation.x += 0.0015
      }

      if (this.raycaster && this.cucumber && this.mouseMoved && this.stream) {
        this.raycaster.setFromCamera(this.mouse, this.camera)

        const intersects = this.raycaster.intersectObject(this.cucumber.children[0])
        if (intersects.length > 0) {
          this.hovering = true
        } else {
          this.hovering = false
        }
      }

      if (this.cucumberReflectionCamera && !this.hovering) {
        this.cucumberReflectionCamera.update(this.renderer, this.scene)
      }


      this.renderer.render(this.scene, this.camera)
      requestAnimationFrame(this.animate)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.main-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transform: scale(0.95) translate3d(0,0,0);
  transform-origin: center;
  opacity: 0;
  transition: transform 4s, opacity 4s;
  &.hovering {
    transform: scale(1) translate3d(0,0,0);
    cursor: none;
  }
  &.init {
    opacity: 1;
  }
  * {
    position: absolute;
  }
}
</style>
